<template lang="pug">
v-snackbar(
    v-if="showAlert"
    bottom
    close
    :value="show"
    :timeout="-1"
    max-width="60vw"
    color="primary"
  )
    template(#action)
      v-btn(
        icon
        small
        @click="show = false"
      )
        v-icon mdi-close-circle
    v-icon.mr-4 mdi-information-outline
    span.mr-2
      | Сейчас вы видите только те мероприятия, что проводятся непосредственно на платформе
      a(:href="platform.current" target="_blank"): b  {{ !$conf.isVcht ? 'региональных' : 'федеральных' }} мероприятий
      | , но вы можете расширить свои возможности, подключив отображение и других мероприятий,
      |  проводимых на платформе
      a(:href="platform.other" target="_blank"): b  {{ $conf.isVcht ? 'региональных' : 'федеральных' }} мероприятий
      |  связав личные кабинеты указанных платформ.
    .mt-4.d-flex.align-center
      v-btn.mr-4(
        outlined
        small
        to="/my-profile"
      )
        | Связать
      v-checkbox.pt-0.mt-0(
        v-model="ignore"
        hide-details
        dense
        label="Больше не показывать"
      )
</template>

<script>
import { SYSTEMS, SYSTEMS_NAMES } from '../../modules/Auth/constants';

export default {
  name: 'LinkProfileAlert',

  data() {
    return {
      show: true,
      ignore: false,
    };
  },

  computed: {
    showAlert() {
      const ignoredIds = JSON.parse(window.localStorage.getItem('ignore_link_alert')) || [];
      const userIdx = ignoredIds.findIndex((id) => id === this.$user.data.id);
      return !this.$user.data.social?.length
        && this.$route.path !== '/my-profile'
        && this.$user.hasRoles([this.$conf.ROLES.member, this.$conf.ROLES.certificate])
        && !(userIdx + 1);
    },

    platform() {
      const { isVcht } = this.$conf;
      return {
        current: isVcht ? SYSTEMS[SYSTEMS_NAMES.VCHT] : SYSTEMS[SYSTEMS_NAMES.EVENTS],
        other: !isVcht ? SYSTEMS[SYSTEMS_NAMES.VCHT] : SYSTEMS[SYSTEMS_NAMES.EVENTS],
      };
    },
  },

  watch: {
    show(v) {
      if (!v) {
        const ignoredIds = JSON.parse(window.localStorage.getItem('ignore_link_alert')) || [];
        if (this.ignore) {
          ignoredIds.push(this.$user.data.id);
          window.localStorage.setItem('ignore_link_alert', JSON.stringify(ignoredIds));
        }
      }
    },
  },

  // methods: {
  //   setDontShow(val) {
  //     const ignoredIds = JSON.parse(window.localStorage.getItem('ignoreLinkAlert')) || [];
  //     if (val) {
  //       ignoredIds.push(this.$user.data.id);
  //     } else {
  //       const userIdx = ignoredIds.findIndex((id) => id === this.$user.data.id);
  //       if (userIdx + 1) {
  //         ignoredIds.splice(userIdx, 1);
  //       }
  //     }
  //     window.localStorage.setItem('ignoreLinkAlert', JSON.stringify(ignoredIds));
  //   },
  // },
};
</script>
